import { jsx, Fragment } from 'react/jsx-runtime';
import { useQueryResourceAncestors } from '../../resource-detail/queries/useQueryResourceAncestors.js';
import { useQueryUserInfo } from '../../user/queries/useQueryUserInfo.js';
import { useMemo } from 'react';
import { styled } from 'styled-components';
import { ResourcePath, NodePathName } from './ResourcePath/ResourcePath.js';
import { generatePath } from '@fabric-app/utils/url/routing';
import { appRoutes } from '../../app/routing/routes.config.js';
import { getResourceNamePlaceholder } from '../utils/getResourceTitle.js';
import AvatarUser from '../../user/components/AvatarUser/AvatarUser.js';
import { renderResourceIcon } from '../../resource-detail/components/ResourceIcon/renderResourceIcon.js';
import { Link } from '@fabric-app/compat';
import { useShouldRenderPathItemBasedOnViewportWidth } from './ResourceList/ResourceSearchResultList/ResourcePreviewItem/ResourcePathAndName.js';

const ResourceTopBarPath = ({ resource, onClickFolder }) => {
  const { accessibleAncestors } = useQueryResourceAncestors(resource.id);
  const { data: user } = useQueryUserInfo();
  const renderedPath = useMemo(() => {
    const rootAkaSpaceId = resource.root?.folder.id;
    const res = accessibleAncestors.map((item) => {
      return {
        id: item.id,
        name: item.name,
        onClick: onClickFolder ? (e) => {
          e?.stopPropagation();
          e?.preventDefault();
          onClickFolder(item.id);
        } : void 0,
        href: onClickFolder ? void 0 : item.id === rootAkaSpaceId ? generatePath(appRoutes.space.detail, {
          spaceId: rootAkaSpaceId
        }) : generatePath(appRoutes.folder.detail, {
          folderId: item.id
        })
      };
    });
    res.push({
      id: resource.id,
      name: resource.name || getResourceNamePlaceholder(resource),
      icon: renderResourceIcon(resource, {
        size: 16
      })
    });
    return res;
  }, [
    accessibleAncestors,
    onClickFolder,
    resource
  ]);
  const isRootOwner = resource.root?.folder.user && resource.root.folder.user.id !== user?.id ? false : true;
  const shouldRenderPathItem = useShouldRenderPathItemBasedOnViewportWidth();
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx(TopBarPath, {
      path: renderedPath,
      showLeadingDivider: isRootOwner,
      shouldRenderPathItem,
      startElement: !isRootOwner ? resource?.root?.folder.user && /* @__PURE__ */ jsx(AvatarUser, {
        user: resource.root.folder.user,
        size: 16
      }) : /* @__PURE__ */ jsx(NodePathName, {
        style: {
          flexShrink: 0
        },
        "data-testid": "breadcrumb-spaces",
        href: appRoutes.space.list,
        as: Link,
        children: "Spaces"
      })
    })
  });
};
const TopBarPath = styled(ResourcePath).attrs((props) => {
  return {
    showLeadingDivider: true,
    ...props
  };
}).withConfig({
  displayName: "ResourceTopBarPath__TopBarPath",
  componentId: "sc-af99ac96-0"
})([
  `padding-left:0.375rem;`
]);

export { ResourceTopBarPath, TopBarPath };
//# sourceMappingURL=ResourceTopBarPath.js.map
